// Partie Javascript servant à controler si la NavBar est transparente ou NON
const navbar = document.getElementById("navbar")
let scrolled = false

window.onscroll = function () {
  if (window.scrollY > 100) {
    navbar.classList.remove("top")
    if (!scrolled) {
      navbar.style.transform = "translateY(-86px)"
    }
    setTimeout(() => {
      navbar.style.transform = "translateY(0)"
      scrolled = true
    }, 200)
  } else {
    navbar.classList.add("top")
    scrolled = false
  }
}
